export const $blackColor = '#000000';
export const $demiBlackColor = '#111111';
export const $whiteColor = '#FFFFFF';
export const $wheatColor = 'wheat';

export const $systoleColor = '#FF006C';
export const $diastoleColor = '#0899FF';

export const $selectedColor = '#F0B323';
export const $highlightedColor = '#FFDB85';
export const $disabledColor = '#A2A9B1';
export const $disabledLightPanelFontColor = '#999999';
export const $disabledLightPanelFontColorHighlighted = '#777777';
export const $disabledDarkPanelFontColor = '#DDDDDD';
export const $disabledDarkPanelFontColorHighlighted = $disabledDarkPanelFontColor;

export const $selectedTableRowColor = $selectedColor;
export const $highlightedTableRowColor = $highlightedColor;
export const $selectedObjectColor = $selectedColor;

export const $disabledObjectColor = $disabledColor;

export const $labelColor = '#FFC949';
export const $labelBgColor = '#00000066';
export const $labelHoveredBgColor = '#00000088';
export const $labelSelectedBgColor = '#00000099';

export const $lightThemeMainBgColor = '#F1F1F1';
export const $lightThemeSecondaryBgColor = 'rgba(255, 255, 255, 0.9)';
export const $lightPanelsFont = '#202A34';
export const $darkPanelsFont = 'rgb(201, 209, 217)';
export const $darkDisabledFont = 'rgba(201, 209, 217,0.26)';

export const $lightCollapsibleBoxHeaderBgColor = 'rgba(200, 200, 255, 0.15)';
export const $darkCollapsibleBoxHeaderBgColor = 'rgba(200, 200, 255, 0.3)';
export const $lightCollapsibleBoxBgColor = '#f1f1f1';
export const $darkCollapsibleBoxBgColor = '#20282f';
